
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import isNil from 'lodash/isNil';

import Loading from '../../components/common/Loading';
import IfElseComp from '../../components/common/IfElseComp';

import AppNavigation from '../../components/app/AppNavigation';
import IsknActualInfo from '../../components/isknActual/IsknActualInfo';

const classNames = mergeStyleSets({
    IsknActualInfo: {
        height: '100vh',
        width: '100vw'
    },
    content: {
        paddingLeft: 16
    }
});

const Content = ({project, history}) => {

    return (
        <Stack verticalFill>
            <AppNavigation pageId="isknActualInfo" project={project} />
            <Stack.Item grow className={classNames.content}>
                <IsknActualInfo />
            </Stack.Item>
        </Stack>
    );
}

const IsknActualInfoPageView = ({project, history}) => {
    return (
        <Stack verticalFill className={classNames.IsknActualInfo}>
            <Stack.Item grow>
                <IfElseComp
                    cond={!isNil(project)}
                    trueComp={<Content project={project} history={history} />}
                    falseComp={<Loading />}
                />
            </Stack.Item>
        </Stack>
    );
}

export default IsknActualInfoPageView;
